import React from "react";
import { Helmet } from "react-helmet-async";

const SEO = ({ 
  title, 
  description, 
  keywords, 
  image, 
  url, 
  type = "website",
  author = "Bhole Cab Service",
  publishedTime,
  modifiedTime,
  tags = []
}) => {
  const siteTitle = "Bhole Cab Service";
  const fullTitle = title ? `${title} | ${siteTitle}` : siteTitle;
  const defaultDescription = "Reliable, comfortable rides across Vadodara. Book your cab for local travel, outstation trips, airport transfers, and corporate travel.";
  const defaultImage = `${window.location.origin}/og-image.jpg`;
  const currentUrl = url || window.location.href;
  const siteKeywords = "Bhole Cab Service, cab service Vadodara, taxi Vadodara, airport pickup, round trip, one way taxi, local taxi Vadodara, cab booking, outstation cab, corporate travel";

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description || defaultDescription} />
      <meta name="keywords" content={keywords || siteKeywords} />
      <meta name="author" content={author} />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={currentUrl} />

      {/* Open Graph Meta Tags */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description || defaultDescription} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:image" content={image || defaultImage} />
      <meta property="og:site_name" content={siteTitle} />
      <meta property="og:locale" content="en_US" />
      
      {publishedTime && (
        <meta property="article:published_time" content={publishedTime} />
      )}
      {modifiedTime && (
        <meta property="article:modified_time" content={modifiedTime} />
      )}
      {tags.length > 0 && (
        <meta property="article:tag" content={tags.join(", ")} />
      )}

      {/* Twitter Card Meta Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description || defaultDescription} />
      <meta name="twitter:image" content={image || defaultImage} />
      <meta name="twitter:site" content="@bholecab" />
      <meta name="twitter:creator" content="@bholecab" />

      {/* Theme Color */}
      <meta name="theme-color" content="#0F3D3E" />
      
      {/* Mobile */}
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />
      <meta name="apple-mobile-web-app-title" content={siteTitle} />
      
      {/* Geo Tags */}
      <meta name="geo.region" content="IN-GJ" />
      <meta name="geo.placename" content="Vadodara" />
      <meta name="geo.position" content="22.3072;73.1812" />
      <meta name="ICBM" content="22.3072, 73.1812" />

      {/* Schema.org markup for Google+ */}
      <meta itemProp="name" content={fullTitle} />
      <meta itemProp="description" content={description || defaultDescription} />
      <meta itemProp="image" content={image || defaultImage} />

      {/* Additional SEO */}
      <meta name="distribution" content="global" />
      <meta name="rating" content="general" />
      <meta name="revisit-after" content="7 days" />
    </Helmet>
  );
};

export default SEO;